<template>
  <div class="input-group mr-3">
    <label>{{label}}</label>
    <input type="text" @keyup="changeInput">
    <i class="bar"></i>
  </div>
</template>

<script>
export default {
  name: "inputMapeo",
  props: {
    label: {type: String, required: true},
    attr: {type: String, required: true}
  },
  methods: {
    changeInput({target}) {
      this.$emit('changeInput', {
        attr: this.attr,
        value: target.value
      })
    }
  }
}
</script>

<style scoped>

</style>
